<template>
  <div class="app-container member-detail">
    <basic-container v-loading="loading">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="first">
          <el-row class="member-detail-item">
            <el-col :span="3" class="head">ID:</el-col>
            <el-col :span="16">{{memberDetail.memberId}}</el-col>
          </el-row>
          <div class="operation" v-if="permissions.official_member_edit">
            <el-button v-show="isEdit" @click="cancelEdit">取消</el-button>
            <el-button type="primary" @click="switchMode">{{isEdit ? '保存' : '编辑'}}</el-button>
          </div>
          <el-row class="member-detail-item">
            <el-col :span="3">头像:</el-col>
            <el-col :span="16">
              <img class="avatar-right" v-show="!isEdit" :src="avatarImg" />
              <div>
                <div class="image">
                  <img class="origin-avatar" :src="avatarImg" v-show="isEdit"/>
                </div>
                <div class="upload-btn" v-show="isEdit">
                  <el-button @click="handleImageChange" size="small" type="primary">重新上传</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="3">官方号名称:</el-col>
            <el-col :span="16" v-show="!isEdit">{{memberDetail.nickname}}</el-col>
            <el-col :span="16" v-show="isEdit">
              <el-input v-model="nickname"></el-input>
            </el-col>
          </el-row>
          <el-row class="member-detail-item">
            <!-- <el-col :span="3">官方号等级:</el-col>
            <el-col :span="6" v-show="!isEdit">{{memberDetail.officialTierName}}</el-col>
            <el-col :span="6" v-show="isEdit">
              <el-select placeholder="选择官方号等级" v-model="tierId" clearable>
                <el-option
                  v-for="item in accountTierOptions"
                  :key="item.tierId"
                  :label="item.officialName"
                  :value="item.tierId">
                </el-option>
              </el-select>
            </el-col> -->
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="3">帖子数:</el-col>
            <el-col :span="16">{{ memberDetail.postCount }}</el-col>
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="3">创建时间：</el-col>
            <el-col :span="16">{{memberDetail.insertedTime}}</el-col>
          </el-row>
          <!-- <avue-crud ref="crud"
            :option="tableOption"
            :data="relatedlist"
            :table-loading="listLoading"
            :before-open="handleOpenBefore"
            @refresh-change="handleRefreshChange">

            <template slot="menuLeft">
              <span>关联员工列表</span>
            </template>
            <template slot="menuRight">
              <el-button type="primary" @click="showRelateDialog" icon="el-icon-plus" size="small" v-if="permissions.official_member_add">关联员工</el-button>
            </template>

            <template slot-scope="scope" slot="avatar">
                  <div class="admin-image">
                    <img class="image" :src="scope.row.avatar">
                  </div>
            </template>

            <template slot="postCount"
                      slot-scope="scope">
              {{scope.row.postCount ? scope.row.postCount : 0}}
            </template>

            <template slot="columnOpenedCount"
                      slot-scope="scope">
              <a href="javascript:void(0);" @click="toColumnList(scope.row.memberId);"
                  class="member-list-container-button">
                {{scope.row.columnOpenedCount}}</a>
            </template>

            <template slot="commentCount"
                      slot-scope="scope">
                {{scope.row.commentCount}}
            </template>

            <template slot="menu"
                      slot-scope="scope">
              <el-button size="mini"
                  type="text"
                  icon="el-icon-close"
                  v-if="permissions.official_member_inactive && scope.row.isActive"
                  @click="handleActive(scope.row,scope.index)">失效
              </el-button>
              <el-button size="mini"
                  type="text"
                  icon="el-icon-plus"
                  v-if="permissions.official_member_active && !scope.row.isActive"
                  @click="handleActive(scope.row,scope.index)">生效
              </el-button>
            </template>
          </avue-crud> -->
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <el-dialog
      title="关联员工"
      :visible.sync="relatedDialogVisible"
      width="680px"
      custom-class="preview-img-dialog">
      <el-row>
        <el-col :span="4">
          关联员工号：
        </el-col>
        <el-col :span="18">
           <el-input v-model="relatedPersonalUnionId" placeholder="多位请用英文逗号隔开"></el-input>
        </el-col>
      </el-row>
      <span slot="footer">
        <template>
          <el-button @click="relatedDialogVisible = false">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="addRelatedUnionId">确认</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getObj, addRelatedUnionId, updateRelatedStatus } from '@/api/admin/member'
  import {mapGetters} from 'vuex'
  import anonymousImage from '@/static/images/member/anonymous.svg';
  import { getOSSAvatar } from '@/api/basic/aliyunoss'
  import { updateOfficialMember } from '@/api/admin/member'
  import { getFileKeyAsync } from '@/util/util'
  import uploadService from '@/common/common-logic/upload-service'
  import { relatedPersonalTableOption } from '@/const/crud/admin/member'
  import { fetchAccountTierList } from '@/api/admin/tier'

  const initDetail = vm => {
    getObj(vm.id).then(response => {
      let data = response.data
        if (response.status == 200) {
          vm.nickname = data.data.nickname
          vm.relatedlist = data.data.relatedPersonalMemberList;
          vm.tierId = data.data.tierId
          formatMemberDetail(vm.memberDetail, data.data)
          vm.avatarImg = vm.memberDetail.avatar
          vm.unionId = vm.memberDetail.unionId
        } else {
          vm.$message({
            showClose: true,
            message: '无法查看该员工详情',
            type: 'error'
          })
        }
    }).catch(error => {
      vm.$message({
        message: '获取员工详情失败',
        type: 'error'
      })
    })
  }

  const formatMemberDetail = (vm, data) => {
    vm.memberId = data.memberId;
    vm.unionId = data.unionId;
    vm.officialTierName = data.officialTierName;

    if (!data.avatar) vm.avatar = anonymousImage;
    else vm.avatar = data.avatar;

    if (!data.nickname) vm.nickname = "--";
    else vm.nickname = data.nickname;

    if (!data.postCount || data.postCount == 0) vm.postCount = 0;
    else vm.postCount = data.postCount;

    if (!data.insertedTime) vm.insertedTime = "--";
    else vm.insertedTime = data.insertedTime;
  }

  export default {
    data () {
      return {
        // 基本资料详情窗口
        activeName: "first",
        loading: false,
        isEdit: false,
        memberDetail: {
          memberId: undefined,
          unionId: "",
          avatar: "",
          nickname: "",
          memberType: 0,
          insertedTime: "",
          postCount : 0,
          officialTierName: "",
        },
        avatarImg: null,
        nickname: '',
        relatedPersonalUnionId: "",
        tableOption: relatedPersonalTableOption,
        relatedlist: [],
        relatedDialogVisible: false,
        tierId: null,
        accountTierOptions: [],
      }
    },
    watch: {
      $route () {
        this.isEdit = this.$route.path.includes('edit')
        this.id = this.$route.params.id
        initDetail(this)
      }
    },
    mounted () {
      this.isEdit = this.$route.path.includes('edit')
      this.id = this.$route.params.id
      initDetail(this)
      this.loadAccountTierOptions()
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      cancelEdit () {
        if (this.$route.path.includes('edit')) {
          this.$router.$avueRouter.closeTag()
          this.$router.go(-1)
        } else {
          this.isEdit = false
          initDetail(this)
        }
      },
      switchMode () {
        if (this.isEdit) {
          this.submit()
        } else {
          this.isEdit = true
        }
      },
      handleImageChange (file, fileList) {
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }
          this.avatarImg = list[0].contentUrl
        }, 1);
      },
      validate () {
        if (!this.nickname) {
          this.$message({
            message: '官方号名称不能为空',
            type: 'error'
          })
          return false
        }
        if (!this.tierId) {
          this.$message({
            message: '官方号等级不能为空',
            type: 'error'
          })
          return false
        }
        return true
      },
      getParams () {
        let params = { nickname: this.nickname, tierId: this.tierId }
        params.avatar = this.avatarImg;
        if (this.relatedPersonalUnionId) {
          params.relatedPersonalUnionId = this.relatedPersonalUnionId;
        }
        params.officialUnionId = this.unionId;
        return params
      },
      submit () {
        if (!this.validate()) {
          return false
        }
        updateOfficialMember(this.id, this.getParams()).then(response => {
          if (response.data.code === 0) {
            if (this.$route.path.includes('edit')) {
              this.$router.$avueRouter.closeTag()
              this.$router.push({
                path: `/upms/member/official/detail/${this.id}`,
              })
            } else {
              this.isEdit = false;
              initDetail(this);
            }
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$refs.avatarPicture.clearFiles();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      handleActive(row, index){
        this.dialogDetailVisible = false;
        if (row.relatedOfficialMemberId){
          if (row.isActive == false) {
            this.$confirm('该对象已是失效状态，是否确认该员工"' + row.realname + '"'+ '的官方号操作权限生效', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(function () {
              let params = {
                id: row.id,
                isActive: true
              }
              return updateRelatedStatus(params);
            }).then(() => {
              initDetail(this);
              this.$message({
                showClose: true,
                message: '生效成功',
                type: 'success'
              })
            }).catch(function () {
            })
          } else {
            this.$confirm('是否确认该员工"' + row.realname + '"'+ '的官方号操作权限失效', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(function () {
              let params = {
                id: row.id,
                isActive: false
              }
              return updateRelatedStatus(params);
            }).then(() => {
              initDetail(this);
              this.$message({
                showClose: true,
                message: '失效成功',
                type: 'success'
              })
            }).catch(function () {
            })
          }
        }
      },
      showRelateDialog() {
        this.relatedPersonalUnionId = ''
        this.relatedDialogVisible = true;
      },
      addRelatedUnionId() {
        if (!this.relatedPersonalUnionId) {
          this.$message({
            message: '关联员工号不能为空',
            type: 'error'
          })
          return false
        }
        addRelatedUnionId({memberId: this.id, relatedPersonalUnionId: this.relatedPersonalUnionId }).then(res => {
          if (res.data.data) {
            this.$message({
              message: '关联成功',
              type: 'success'
            })
            this.relatedDialogVisible = false;
            initDetail(this)
          }
        })
      },
      loadAccountTierOptions() {
        fetchAccountTierList().then(response => {
          this.accountTierOptions = response.data.data;
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
.member-detail {
  .member-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      margin-top: -8px;
      color: #409EFF;
      font-size: 15px;
      text-align: center;
      font-weight: 500;
    }
    &-editButton {
      margin-left: 10px;
    }
  }
  .avatar-right {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    vertical-align: top;
    object-fit: cover;
  }
  .image{
    position: relative;
    width: 148px;
    .origin-avatar {
      width: 148px;
      height: 148px;
      float: left;
      margin-right: 8px;
      border-radius: 50%;
    }
  }
  .upload-btn {
    display: flex;
    width: 148px;
    height: 148px;
    border: 3px #E4E7ED dashed;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .member-detail-edit {
    margin-top: 40px;
    &-button {
      position: absolute;
      right: 0px;
      top: 13px;
      padding: 8px 12px;
    }
  }
  .operation {
    text-align: right
  }
  &-tagForm {
    width: 550px;
  }
  &-save {
    padding: 8px 12px;
  }
  &-cancel {
    padding: 8px 12px;
  }
}
/deep/ .el-upload-list__item-thumbnail {
  border-radius: 50%;
}
</style>
